<template>
  <div>
    <NavBar></NavBar>
    <Breadcrumb></Breadcrumb>
    <div class="container">
      <div class="row mt-3">
        <div class="col-lg-3">
          <SideBar></SideBar>
        </div>
        <div class="col-lg-9 content">
          <div class="pages">
            <div>
              <section id="ContactForm" class="section">
                <div class="container">
                  <h1 class="main-title">{{ $t("jobApplication") }}</h1>
                  <form
                    ref="contactUsForm"
                    @submit.prevent="submitted"
                    autocomplete="off"
                  >
                    <div class="row">
                      <div class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2">
                        <div class="form-group row">
                          <label
                            class="col-sm-4 col-form-label blue"
                            for="userName"
                            >{{ $t("jobAppFormLabels.name") }} *</label
                          >
                          <input
                            type="text"
                            id="userName"
                            class="form-control col-sm-8"
                            v-model="userData.userName"
                            :class="{ errror: $v.userData.userName.$error }"
                            @blur="$v.userData.userName.$touch()"
                          />
                        </div>
                        <div v-if="$v.userData.userName.$error">
                          <p
                            v-if="!$v.userData.userName.required"
                            class="text-danger mb-3"
                          >
                            {{ $t("jobAppFormLabels.userNameRequired") }}
                          </p>
                        </div>
                        <div class="form-group row">
                          <label
                            class="col-sm-4 col-form-label blue"
                            for="userSurname"
                            >{{ $t("jobAppFormLabels.surname") }} *</label
                          >
                          <input
                            type="text"
                            id="userSurname"
                            class="form-control col-sm-8"
                            v-model="userData.userSurname"
                            :class="{ errror: $v.userData.userSurname.$error }"
                            @blur="$v.userData.userSurname.$touch()"
                          />
                        </div>
                        <div v-if="$v.userData.userSurname.$error">
                          <p
                            v-if="!$v.userData.userSurname.required"
                            class="text-danger mb-3"
                          >
                            {{ $t("jobAppFormLabels.userSurameRequired") }}
                          </p>
                        </div>
                        <div class="form-group row">
                          <label
                            class="col-sm-4 col-form-label blue"
                            for="identificationNumber"
                            >{{
                              $t("jobAppFormLabels.identificationNumber")
                            }}</label
                          >
                          <input
                            type="text"
                            id="identificationNumber"
                            class="form-control col-sm-8"
                            v-model="userData.identificationNumber"
                            :class="{
                              error: $v.userData.identificationNumber.$error,
                            }"
                            @blur="$v.userData.identificationNumber.$touch()"
                          />
                        </div>

                        <div class="form-group row">
                          <label class="col-sm-4 col-form-label blue"
                            >{{ $t("jobAppFormLabels.gender") }} *</label
                          >
                          <div class="col-sm-8">
                            <label class="radio-inline">
                              <input
                                type="radio"
                                v-model="userData.gender"
                                :value="genderValues.male"
                              />
                              {{
                                $t(
                                  "jobAppFormLabels.genderOption.genderOption_1",
                                )
                              }}
                            </label>
                            &nbsp;
                            <label class="radio-inline">
                              <input
                                type="radio"
                                v-model="userData.gender"
                                :value="genderValues.female"
                              />
                              {{
                                $t(
                                  "jobAppFormLabels.genderOption.genderOption_2",
                                )
                              }}
                            </label>
                          </div>
                        </div>
                        <div v-if="$v.userData.gender.$error">
                          <p
                            v-if="!$v.userData.gender.required"
                            class="text-danger mb-3"
                          >
                            {{ $t("jobAppFormLabels.genderRequired") }}
                          </p>
                        </div>

                        <div class="form-group row">
                          <label
                            class="col-sm-4 col-form-label blue"
                            for="dateOfBirth"
                            >{{ $t("contactFormLabels.birthDate") }} *</label
                          >
                          <input
                            type="date"
                            id="dateOfBirth"
                            class="form-control col-sm-8"
                            v-model="userData.dateOfBirth"
                            :class="{ errror: $v.userData.dateOfBirth.$error }"
                            @blur="$v.userData.dateOfBirth.$touch()"
                          />
                        </div>
                        <div v-if="$v.userData.dateOfBirth.$error">
                          <p
                            v-if="!$v.userData.dateOfBirth.required"
                            class="text-danger mb-3"
                          >
                            {{ $t("jobAppFormLabels.birthDateRequired") }}
                          </p>
                        </div>

                        <div class="form-group row">
                          <label
                            class="col-sm-4 col-form-label blue"
                            for="maritalStatus"
                            >{{ $t("jobAppFormLabels.maritalStatus") }} *</label
                          >
                          <select
                            id="maritalStatus"
                            class="form-control col-sm-8"
                            v-model="userData.maritalStatus"
                            :class="{ error: $v.userData.maritalStatus.$error }"
                            @blur="$v.userData.maritalStatus.$touch()"
                          >
                            <option value="">{{
                              $t("jobAppFormLabels.select")
                            }}</option>
                            <option :value="maritalStatusValues.married"
                              >{{
                                $t(
                                  "jobAppFormLabels.maritalStatusOption.maritalStatusOption_1",
                                )
                              }}
                            </option>
                            <option :value="maritalStatusValues.single"
                              >{{
                                $t(
                                  "jobAppFormLabels.maritalStatusOption.maritalStatusOption_2",
                                )
                              }}
                            </option>
                          </select>
                        </div>
                        <div v-if="$v.userData.maritalStatus.$error">
                          <p
                            v-if="!$v.userData.maritalStatus.required"
                            class="text-danger mb-3"
                          >
                            {{ $t("jobAppFormLabels.maritalStatusRequired") }}
                          </p>
                        </div>

                        <div class="form-group row">
                          <label
                            class="col-sm-4 col-form-label blue"
                            for="education"
                            >{{ $t("education") }} *</label
                          >
                          <select
                            id="education"
                            class="form-control col-sm-8"
                            v-model="userData.education"
                            :class="{ errror: $v.userData.education.$error }"
                            @blur="$v.userData.education.$touch()"
                          >
                            <option value="">{{
                              $t("jobAppFormLabels.select")
                            }}</option>
                            <option>{{
                              $t("jobAppFormLabels.education.education_1")
                            }}</option>
                            <option>{{
                              $t("jobAppFormLabels.education.education_2")
                            }}</option>
                            <option>{{
                              $t("jobAppFormLabels.education.education_3")
                            }}</option>
                            <option>{{
                              $t("jobAppFormLabels.education.education_4")
                            }}</option>
                          </select>
                        </div>
                        <div v-if="$v.userData.education.$error">
                          <p
                            v-if="!$v.userData.education.required"
                            class="text-danger mb-3"
                          >
                            {{ $t("jobAppFormLabels.educationRequired") }}
                          </p>
                        </div>

                        <div class="form-group row">
                          <label class="col-sm-4 col-form-label blue">{{
                            $t("jobAppFormLabels.foreignLanguage")
                          }}</label>

                          <!-- Language selection -->
                          <select
                            class="form-control col-sm-8"
                            v-model="userData.currentLanguage"
                          >
                            <option value="">{{
                              $t("jobAppFormLabels.select")
                            }}</option>
                            <option :value="foreignLanguageValues.english">{{
                              $t(
                                "jobAppFormLabels.foreignLanguageOption.english",
                              )
                            }}</option>
                            <option :value="foreignLanguageValues.arabic">{{
                              $t(
                                "jobAppFormLabels.foreignLanguageOption.arabic",
                              )
                            }}</option>
                            <option :value="foreignLanguageValues.french">{{
                              $t(
                                "jobAppFormLabels.foreignLanguageOption.french",
                              )
                            }}</option>
                            <option :value="foreignLanguageValues.persian">{{
                              $t(
                                "jobAppFormLabels.foreignLanguageOption.persian",
                              )
                            }}</option>
                            <option :value="foreignLanguageValues.russian">{{
                              $t(
                                "jobAppFormLabels.foreignLanguageOption.russian",
                              )
                            }}</option>
                            <option :value="foreignLanguageValues.other">{{
                              $t("jobAppFormLabels.foreignLanguageOption.other")
                            }}</option>
                          </select>
                        </div>

                        <div
                          class="form-group row"
                          :class="{
                            'd-none':
                              userData.currentLanguage ===
                              foreignLanguageValues.other,
                          }"
                        >
                          <label class="col-sm-4 col-form-label blue">{{
                            $t("jobAppFormLabels.level")
                          }}</label>

                          <select
                            class="form-control col-sm-8"
                            v-model="userData.currentLevel"
                          >
                            <option value="">{{
                              $t("jobAppFormLabels.select")
                            }}</option>
                            <option :value="foreignLanguageLevelValues.good"
                              >{{
                                $t("jobAppFormLabels.foreignLanguageLevel.good")
                              }}
                            </option>
                            <option
                              :value="foreignLanguageLevelValues.medium"
                              >{{
                                $t(
                                  "jobAppFormLabels.foreignLanguageLevel.medium",
                                )
                              }}</option
                            >
                            <option :value="foreignLanguageLevelValues.bad"
                              >{{
                                $t("jobAppFormLabels.foreignLanguageLevel.bad")
                              }}
                            </option>
                          </select>
                        </div>

                        <div class="form-group row">
                          <div class="col-sm-8 offset-sm-4">
                            <button
                              type="button"
                              class="btn btn-primary"
                              @click="addLanguage"
                            >
                              {{ $t("jobAppFormLabels.add") }}
                            </button>
                          </div>
                        </div>

                        <!-- Display added languages -->
                        <div
                          v-for="(language, index) in userData.languages"
                          :key="index"
                        >
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label blue"></label>
                            <div class="col-sm-8">
                              <p
                                style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 0.5rem;"
                              >
                                {{ language.language }} - {{ language.level }}
                                <button
                                  style="width: auto; background: red; border-color: red; min-height: auto;"
                                  type="button"
                                  class="btn btn-danger btn-sm"
                                  @click="removeLanguage(index)"
                                >
                                  x
                                </button>
                              </p>
                            </div>
                          </div>
                        </div>

                        <div class="form-group row">
                          <label
                            class="col-sm-4 col-form-label blue"
                            for="homeAddress"
                            >{{ $t("jobAppFormLabels.homeAddress") }} *</label
                          ><br />
                          <!-- Interpolation between <textarea>{{ test }}</textarea> doesn't work!-->
                          <textarea
                            id="homeAddress"
                            rows="5"
                            class="form-control col-sm-8"
                            v-model="userData.homeAddress"
                            :class="{ errror: $v.userData.homeAddress.$error }"
                            @blur="$v.userData.homeAddress.$touch()"
                          ></textarea>
                        </div>
                        <div v-if="$v.userData.homeAddress.$error">
                          <p
                            v-if="!$v.userData.homeAddress.required"
                            class="text-danger mb-3"
                          >
                            {{ $t("jobAppFormLabels.homeAddressRequired") }}
                          </p>
                        </div>

                        <div class="form-group row">
                          <label
                            class="col-sm-4 col-form-label blue"
                            for="location"
                            >{{ $t("contactFormLabels.city") }} *</label
                          >
                          <select
                            id="location"
                            class="form-control col-sm-8"
                            v-model="selectedLocation"
                            :class="{ errror: $v.selectedLocation.$error }"
                            @blur="$v.selectedLocation.$touch()"
                          >
                            <option value="">{{
                              $t("jobAppFormLabels.select")
                            }}</option>
                            <option
                              v-for="(location, key) in locations"
                              :key="key"
                            >
                              {{ location }}
                            </option>
                          </select>
                        </div>
                        <div v-if="$v.selectedLocation.$error">
                          <p
                            v-if="!$v.selectedLocation.required"
                            class="text-danger mb-3"
                          >
                            {{
                              $t("jobAppFormLabels.selectedLocationRequired")
                            }}
                          </p>
                        </div>

                        <div class="form-group row">
                          <label class="col-sm-4 col-form-label blue" for="town"
                            >{{ $t("jobAppFormLabels.town") }} *</label
                          >
                          <input
                            type="text"
                            id="town"
                            class="form-control col-sm-8"
                            v-model="town"
                            :class="{ errror: $v.town.$error }"
                            @blur="$v.town.$touch()"
                          />
                        </div>
                        <div v-if="$v.town.$error">
                          <p v-if="!$v.town.required" class="text-danger mb-3">
                            {{ $t("jobAppFormLabels.townRequired") }}
                          </p>
                        </div>

                        <div class="form-group row">
                          <label
                            class="col-sm-4 col-form-label blue"
                            for="preferredCity1"
                            >{{
                              $t("jobAppFormLabels.preferredLocation_1")
                            }}
                            *</label
                          >
                          <select
                            id="preferredCity1"
                            class="form-control col-sm-8"
                            v-model="preferredCity1"
                            :class="{ errror: $v.preferredCity1.$error }"
                            @blur="$v.preferredCity1.$touch()"
                          >
                            <option value="">{{
                              $t("jobAppFormLabels.select")
                            }}</option>
                            <option
                              v-for="(location, key) in locations"
                              :key="key"
                            >
                              {{ location }}
                            </option>
                          </select>
                        </div>
                        <div v-if="$v.preferredCity1.$error">
                          <p
                            v-if="!$v.preferredCity1.required"
                            class="text-danger mb-3"
                          >
                            {{
                              $t("jobAppFormLabels.preferredLocation1Required")
                            }}
                          </p>
                        </div>

                        <div class="form-group row">
                          <label
                            class="col-sm-4 col-form-label blue"
                            for="preferredCity2"
                            >{{
                              $t("jobAppFormLabels.preferredLocation_2")
                            }}
                            *</label
                          >
                          <select
                            id="preferredCity2"
                            class="form-control col-sm-8"
                            v-model="preferredCity2"
                            :class="{ errror: $v.preferredCity2.$error }"
                            @blur="$v.preferredCity2.$touch()"
                          >
                            <option value="">{{
                              $t("jobAppFormLabels.select")
                            }}</option>
                            <option
                              v-for="(location, key) in locations"
                              :key="key"
                            >
                              {{ location }}
                            </option>
                          </select>
                        </div>
                        <div v-if="$v.preferredCity2.$error">
                          <p
                            v-if="!$v.preferredCity2.required"
                            class="text-danger mb-3"
                          >
                            {{
                              $t("jobAppFormLabels.preferredLocation2Required")
                            }}
                          </p>
                        </div>

                        <div class="form-group row">
                          <label
                            class="col-sm-4 col-form-label blue"
                            for="militaryStatus"
                            >{{ $t("militaryStatus") }} *</label
                          >
                          <select
                            id="militaryStatus"
                            class="form-control col-sm-8"
                            v-model="userData.militaryStatus"
                            :class="{
                              errror: $v.userData.militaryStatus.$error,
                            }"
                            @blur="$v.userData.militaryStatus.$touch()"
                          >
                            <option value="">{{
                              $t("jobAppFormLabels.select")
                            }}</option>
                            <option>{{
                              $t("jobAppFormLabels.militaryStatus.military_1")
                            }}</option>
                            <option>{{
                              $t("jobAppFormLabels.militaryStatus.military_2")
                            }}</option>
                            <option>{{
                              $t("jobAppFormLabels.militaryStatus.military_3")
                            }}</option>
                          </select>
                        </div>
                        <div v-if="$v.userData.militaryStatus.$error">
                          <p
                            v-if="!$v.userData.militaryStatus.required"
                            class="text-danger mb-3"
                          >
                            {{ $t("jobAppFormLabels.militaryStatusRequired") }}
                          </p>
                        </div>

                        <div class="form-group row">
                          <label class="col-sm-4 col-form-label blue"
                            >{{
                              $t("jobAppFormLabels.drivingLicense")
                            }}
                            *</label
                          >
                          <div class="col-sm-8">
                            <label class="radio-inline">
                              <input
                                type="radio"
                                v-model="userData.drivingLicense"
                                :value="yesNoValues.yes"
                              />
                              {{
                                $t(
                                  "jobAppFormLabels.drivingLicenseOption.drivingLicenseOption_1",
                                )
                              }}
                            </label>
                            &nbsp;
                            <label class="radio-inline">
                              <input
                                type="radio"
                                v-model="userData.drivingLicense"
                                :value="yesNoValues.no"
                              />
                              {{
                                $t(
                                  "jobAppFormLabels.drivingLicenseOption.drivingLicenseOption_2",
                                )
                              }}
                            </label>
                          </div>
                        </div>

                        <div
                          class="form-group row"
                          v-if="userData.drivingLicense === yesNoValues.yes"
                        >
                          <label class="col-sm-4 col-form-label blue">{{
                            $t("jobAppFormLabels.drivingLicenseClass")
                          }}</label>
                          <input
                            type="text"
                            class="form-control col-sm-8"
                            v-model="userData.drivingLicenseClass"
                            :class="{
                              error: $v.userData.drivingLicenseClass.$error,
                            }"
                            @blur="$v.userData.drivingLicenseClass.$touch()"
                          />
                        </div>

                        <div class="form-group row">
                          <label
                            class="col-sm-4 col-form-label blue"
                            for="phoneNumber"
                            >{{ $t("contactFormLabels.phoneNumber") }} *</label
                          >
                          <input
                            type="number"
                            id="phoneNumber"
                            class="form-control col-sm-8"
                            v-model="userData.phoneNumber"
                            :class="{ errror: $v.userData.phoneNumber.$error }"
                            @blur="$v.userData.phoneNumber.$touch()"
                          />
                        </div>

                        <div v-if="$v.userData.phoneNumber.$error">
                          <p
                            v-if="!$v.userData.phoneNumber.required"
                            class="text-danger mb-3"
                          >
                            {{ $t("jobAppFormLabels.phoneNumberRequired") }}
                          </p>
                        </div>

                        <div class="form-group row">
                          <label
                            class="col-sm-4 col-form-label blue"
                            for="email"
                            >{{ $t("contactFormLabels.email") }} *</label
                          >
                          <input
                            type="text"
                            id="email"
                            class="form-control col-sm-8"
                            v-model="userData.email"
                            :class="{ errror: $v.userData.email.$error }"
                            @blur="$v.userData.email.$touch()"
                            autocomplete="off"
                          />
                        </div>
                        <div v-if="$v.userData.email.$error">
                          <p
                            v-if="!$v.userData.email.email"
                            class="text-danger mb-3"
                          >
                            {{ $t("contactFormLabels.emailValid") }}
                          </p>
                          <p
                            v-if="!$v.userData.email.required"
                            class="text-danger mb-3"
                          >
                            {{ $t("contactFormLabels.emailRequired") }}
                          </p>
                        </div>

                        <div class="form-group row">
                          <label class="col-sm-4 col-form-label blue"
                            >{{
                              $t("jobAppFormLabels.totalWorkExperience")
                            }}
                            *</label
                          >

                          <select
                            class="form-control col-sm-8"
                            v-model="userData.totalWorkExperience"
                            :class="{
                              error: $v.userData.totalWorkExperience.$error,
                            }"
                            @blur="$v.userData.totalWorkExperience.$touch()"
                          >
                            <option value="">{{
                              $t("jobAppFormLabels.select")
                            }}</option>
                            <option
                              :value="totalWorkExperienceValues.no_experience"
                              >{{
                                $t(
                                  "jobAppFormLabels.totalWorkExperienceOption.totalWorkExperienceOption_1",
                                )
                              }}</option
                            >
                            <option
                              :value="totalWorkExperienceValues['1_3_years']"
                              >{{
                                $t(
                                  "jobAppFormLabels.totalWorkExperienceOption.totalWorkExperienceOption_2",
                                )
                              }}</option
                            >
                            <option
                              :value="totalWorkExperienceValues['3_5_years']"
                              >{{
                                $t(
                                  "jobAppFormLabels.totalWorkExperienceOption.totalWorkExperienceOption_3",
                                )
                              }}</option
                            >
                            <option
                              :value="totalWorkExperienceValues['5_7_years']"
                              >{{
                                $t(
                                  "jobAppFormLabels.totalWorkExperienceOption.totalWorkExperienceOption_4",
                                )
                              }}</option
                            >
                            <option
                              :value="totalWorkExperienceValues['7_10_years']"
                              >{{
                                $t(
                                  "jobAppFormLabels.totalWorkExperienceOption.totalWorkExperienceOption_5",
                                )
                              }}</option
                            >
                            <option
                              :value="
                                totalWorkExperienceValues['10_plus_years']
                              "
                              >{{
                                $t(
                                  "jobAppFormLabels.totalWorkExperienceOption.totalWorkExperienceOption_6",
                                )
                              }}</option
                            >
                          </select>
                        </div>

                        <div v-if="$v.userData.totalWorkExperience.$error">
                          <p
                            v-if="!$v.userData.totalWorkExperience.required"
                            class="text-danger mb-3"
                          >
                            {{
                              $t("jobAppFormLabels.totalWorkExperienceRequired")
                            }}
                            *
                          </p>
                        </div>

                        <div class="form-group row">
                          <label class="col-sm-4 col-form-label blue"
                            >{{
                              $t("jobAppFormLabels.positionYouApply")
                            }}
                            *</label
                          >

                          <select
                            class="form-control col-sm-8"
                            v-model="userData.positionApplyingFor"
                            :class="{
                              error: $v.userData.positionApplyingFor.$error,
                            }"
                            @blur="$v.userData.positionApplyingFor.$touch()"
                          >
                            <option value="">{{
                              $t("jobAppFormLabels.select")
                            }}</option>
                            <option
                              :value="positionValues.armed_security_officer"
                              >{{
                                $t(
                                  "jobAppFormLabels.positionAppliedForOption.positionAppliedForOption_1",
                                )
                              }}</option
                            >
                            <option
                              :value="positionValues.unarmed_security_officer"
                              >{{
                                $t(
                                  "jobAppFormLabels.positionAppliedForOption.positionAppliedForOption_2",
                                )
                              }}</option
                            >
                            <option
                              :value="positionValues.security_supervisor"
                              >{{
                                $t(
                                  "jobAppFormLabels.positionAppliedForOption.positionAppliedForOption_3",
                                )
                              }}</option
                            >
                            <option
                              :value="
                                positionValues.reception_information_officer
                              "
                              >{{
                                $t(
                                  "jobAppFormLabels.positionAppliedForOption.positionAppliedForOption_4",
                                )
                              }}</option
                            >
                            <option :value="positionValues.k9_handler">{{
                              $t(
                                "jobAppFormLabels.positionAppliedForOption.positionAppliedForOption_5",
                              )
                            }}</option>
                            <option
                              :value="positionValues.administrative_staff"
                              >{{
                                $t(
                                  "jobAppFormLabels.positionAppliedForOption.positionAppliedForOption_6",
                                )
                              }}</option
                            >
                            <option :value="positionValues.managerial_staff">{{
                              $t(
                                "jobAppFormLabels.positionAppliedForOption.positionAppliedForOption_8",
                              )
                            }}</option>
                            <option :value="positionValues.other">{{
                              $t(
                                "jobAppFormLabels.positionAppliedForOption.positionAppliedForOption_7",
                              )
                            }}</option>
                          </select>
                        </div>

                        <div v-if="$v.userData.positionApplyingFor.$error">
                          <p
                            v-if="!$v.userData.positionApplyingFor.required"
                            class="text-danger mb-3"
                          >
                            {{
                              $t("jobAppFormLabels.positionApplyingForRequired")
                            }}
                          </p>
                        </div>

                        <div
                          class="form-group row"
                          v-if="
                            positionsRequiringLicense.includes(
                              userData.positionApplyingFor,
                            )
                          "
                        >
                          <label
                            class="col-sm-4 col-form-label blue"
                            for="securityLicenseIssueDate"
                            >{{
                              $t(
                                "jobAppFormLabels.securityGuardLicenseIssueDate",
                              )
                            }}
                            *</label
                          >
                          <input
                            type="date"
                            id="securityLicenseIssueDate"
                            class="form-control col-sm-8"
                            v-model="userData.securityLicenseIssueDate"
                            :class="{
                              error:
                                $v.userData.securityLicenseIssueDate.$error,
                            }"
                            @blur="
                              $v.userData.securityLicenseIssueDate.$touch()
                            "
                          />
                        </div>
                        <div v-if="$v.userData.securityLicenseIssueDate.$error">
                          <p
                            v-if="
                              !$v.userData.securityLicenseIssueDate.required
                            "
                            class="text-danger mb-3"
                          >
                            {{
                              $t(
                                "jobAppFormLabels.securityLicenseIssueDateRequired",
                              )
                            }}
                          </p>
                        </div>

                        <div
                          class="form-group row"
                          v-if="
                            positionsRequiringLicense.includes(
                              userData.positionApplyingFor,
                            )
                          "
                        >
                          <label
                            class="col-sm-4 col-form-label blue"
                            for="securityLicenseExpiryDate"
                            >{{
                              $t(
                                "jobAppFormLabels.securityGuardLicenseExpiryDate",
                              )
                            }}
                            *</label
                          >
                          <input
                            type="date"
                            id="securityLicenseExpiryDate"
                            class="form-control col-sm-8"
                            v-model="userData.securityLicenseExpiryDate"
                            :class="{
                              error:
                                $v.userData.securityLicenseExpiryDate.$error,
                            }"
                            @blur="
                              $v.userData.securityLicenseExpiryDate.$touch()
                            "
                          />
                        </div>
                        <div
                          v-if="$v.userData.securityLicenseExpiryDate.$error"
                        >
                          <p
                            v-if="
                              !$v.userData.securityLicenseExpiryDate.required
                            "
                            class="text-danger mb-3"
                          >
                            {{
                              $t(
                                "jobAppFormLabels.securityLicenseExpiryDateRequired",
                              )
                            }}
                          </p>
                          <p
                            v-if="
                              !$v.userData.securityLicenseExpiryDate.minDate
                            "
                            class="text-danger mb-3"
                          >
                            {{
                              $t(
                                "jobAppFormLabels.securityLicenseExpiryDateInvalid",
                              )
                            }}
                          </p>
                        </div>

                        <div class="form-group row">
                          <label class="col-sm-4 col-form-label blue"
                            >{{ $t("jobAppFormLabels.shiftWork") }} *</label
                          >
                          <div class="col-sm-8">
                            <label class="radio-inline">
                              <input
                                type="radio"
                                v-model="userData.shiftWork"
                                :value="yesNoValues.yes"
                              />
                              {{
                                $t(
                                  "jobAppFormLabels.shiftWorkOption.shiftWorkOption_1",
                                )
                              }}
                            </label>
                            &nbsp;
                            <label class="radio-inline">
                              <input
                                type="radio"
                                v-model="userData.shiftWork"
                                :value="yesNoValues.no"
                              />
                              {{
                                $t(
                                  "jobAppFormLabels.shiftWorkOption.shiftWorkOption_2",
                                )
                              }}
                            </label>
                          </div>
                        </div>
                        <div v-if="$v.userData.shiftWork.$error">
                          <p
                            v-if="!$v.userData.shiftWork.required"
                            class="text-danger mb-3"
                          >
                            {{ $t("jobAppFormLabels.shiftWorkRequired") }}
                          </p>
                        </div>

                        <div class="form-group row">
                          <b
                            ><label class="col-sm-12 col-form-label blue">{{
                              $t("jobAppFormLabels.contactPerson")
                            }}</label></b
                          >
                        </div>
                        <div class="form-group row">
                          <label class="col-sm-4 col-form-label blue"
                            >{{
                              $t(
                                "jobAppFormLabels.contactPersonOption.contactPersonOption_1",
                              )
                            }}
                            *</label
                          >

                          <input
                            type="text"
                            class="form-control col-sm-8"
                            v-model="userData.emergencyContact.name"
                            :class="{
                              error: !$v.userData.emergencyContact.name
                                .required,
                            }"
                            @blur="$v.userData.emergencyContact.name.$touch()"
                          />
                        </div>

                        <div v-if="$v.userData.emergencyContact.name.$error">
                          <p
                            v-if="!$v.userData.emergencyContact.name.required"
                            class="text-danger mb-3"
                          >
                            {{
                              $t(
                                "jobAppFormLabels.emergencyContactNameRequired",
                              )
                            }}
                          </p>
                        </div>

                        <div class="form-group row">
                          <label class="col-sm-4 col-form-label blue"
                            >{{
                              $t(
                                "jobAppFormLabels.contactPersonOption.contactPersonOption_2",
                              )
                            }}
                            *</label
                          >

                          <select
                            class="form-control col-sm-8"
                            v-model="userData.emergencyContact.relationship"
                            :class="{
                              error:
                                $v.userData.emergencyContact.relationship
                                  .$error,
                            }"
                            @blur="
                              $v.userData.emergencyContact.relationship.$touch()
                            "
                          >
                            <option value="">{{
                              $t("jobAppFormLabels.select")
                            }}</option>
                            <option :value="relationshipValues.mother">{{
                              $t(
                                "jobAppFormLabels.relationshipOption.relationshipOption_1",
                              )
                            }}</option>
                            <option :value="relationshipValues.father">{{
                              $t(
                                "jobAppFormLabels.relationshipOption.relationshipOption_2",
                              )
                            }}</option>
                            <option :value="relationshipValues.sibling">{{
                              $t(
                                "jobAppFormLabels.relationshipOption.relationshipOption_3",
                              )
                            }}</option>
                            <option :value="relationshipValues.spouse">{{
                              $t(
                                "jobAppFormLabels.relationshipOption.relationshipOption_4",
                              )
                            }}</option>
                            <option :value="relationshipValues.child">{{
                              $t(
                                "jobAppFormLabels.relationshipOption.relationshipOption_5",
                              )
                            }}</option>
                            <option :value="relationshipValues.friend">{{
                              $t(
                                "jobAppFormLabels.relationshipOption.relationshipOption_6",
                              )
                            }}</option>
                          </select>
                        </div>

                        <div
                          v-if="
                            $v.userData.emergencyContact.relationship.$error
                          "
                        >
                          <p
                            v-if="
                              !$v.userData.emergencyContact.relationship
                                .required
                            "
                            class="text-danger mb-3"
                          >
                            {{
                              $t(
                                "jobAppFormLabels.emergencyContactRelationshipRequired",
                              )
                            }}
                          </p>
                        </div>

                        <div class="form-group row">
                          <label class="col-sm-4 col-form-label blue"
                            >{{
                              $t(
                                "jobAppFormLabels.contactPersonOption.contactPersonOption_3",
                              )
                            }}
                            *</label
                          >

                          <input
                            type="text"
                            class="form-control col-sm-8"
                            v-model="userData.emergencyContact.phoneNumber"
                            :class="{
                              error: !$v.userData.emergencyContact.phoneNumber
                                .required,
                            }"
                            @blur="
                              $v.userData.emergencyContact.phoneNumber.$touch()
                            "
                          />
                        </div>
                        <div
                          v-if="$v.userData.emergencyContact.phoneNumber.$error"
                        >
                          <p
                            v-if="
                              !$v.userData.emergencyContact.phoneNumber.required
                            "
                            class="text-danger mb-3"
                          >
                            {{
                              $t(
                                "jobAppFormLabels.emergencyContactPhoneNumberRequired",
                              )
                            }}
                          </p>
                        </div>

                        <div class="form-group row">
                          <label class="col-sm-4 col-form-label blue"
                            >{{ $t("kvkkConsent") }} *</label
                          >
                          <div class="col-sm-8">
                            <label class="checkbox-inline">
                              <input
                                type="checkbox"
                                v-model="userData.kvkkConsent"
                                required
                              />
                              <span
                                class="ml-2"
                                v-html="$t('kvkkConsentText')"
                              ></span>
                            </label>
                          </div>
                        </div>

                        <div class="form-group row">
                          <label class="col-sm-4 col-form-label blue"
                            >{{
                              $t("contactFormLabels.candidateConsentText")
                            }}
                            *</label
                          >
                          <div class="col-sm-8">
                            <label class="candidate-consent-row mb-0">
                              <input
                                id="jobCandidateConsent"
                                type="checkbox"
                                v-model="userData.candidateConsent"
                                class="candidate-consent-cb"
                                required
                              />
                              <span class="candidate-consent-text"
                                ><a
                                  href="/tr-TR/kurumsal/calisan-adayi-aydinlatma-ve-acik-riza-metni"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  class="candidate-consent-link"
                                  @click.stop
                                  >{{
                                    $t("contactFormLabels.candidateConsentText")
                                  }}</a
                                ><span class="candidate-consent-tail"
                                  >'ni okudum, onaylıyorum.</span
                                ></span
                              >
                            </label>
                          </div>
                        </div>

                        <div class="row">
                          <div
                            class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2"
                          >
                            <div class="col"></div>
                            <div class="col-xs-12 col-md-8 offset-md-4">
                              <!--mine  -->
                              <vue-recaptcha
                                ref="invisibleRecaptcha"
                                @verify="onVerify"
                                @expired="onExpired"
                                size="invisible"
                                :sitekey="this.sitekey"
                              >
                              </vue-recaptcha>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2">
                        <div class="col"></div>
                        <div
                          class="col-xs-12 col-md-8 offset-md-4"
                          style="display: flex;"
                        >
                          <button
                            :disabled="
                              $v.$invalid ||
                                !userData.kvkkConsent ||
                                !userData.candidateConsent
                            "
                            class="btn btn-primary w-50"
                            @click.prevent="submitted"
                          >
                            {{ $t("jobAppFormLabels.applyButton") }}
                          </button>
                          <button
                            class="btn btn-reset"
                            @click.prevent="resetForm"
                          >
                            {{ $t("jobAppFormLabels.clear") }}
                          </button>
                        </div>
                        <div
                          v-if="$v.$anyError"
                          class="text-danger text-center mb-3 mt-3"
                        >
                          {{ $t("contactFormLabels.fillRequiredFields") }}
                        </div>
                      </div>
                    </div>
                  </form>
                  <hr />
                  <p>
                    <small>{{ $t("contactFormLabels.requiredFields") }}</small>
                  </p>
                  <p>
                    <small>{{ $t("contactFormLabels.note") }}</small>
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>

    <transition name="success-modal-fade">
      <div
        v-if="showSuccessModal"
        class="success-modal-overlay"
        @click="closeSuccessModal"
      >
        <div class="success-modal-content" @click.stop>
          <button
            type="button"
            class="success-modal-close"
            aria-label="Kapat"
            @click="closeSuccessModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <picture>
            <source
              media="(max-width: 767px)"
              :srcset="require('@/assets/img/tav-guvenlik-mobile.jpg')"
            />
            <img
              class="success-modal-img"
              :src="require('@/assets/img/tav-guvenlik-desktop.jpg')"
              alt="Başvurunuz değerlendirmeye alınmıştır"
            />
          </picture>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";

/* mine*/
import VueRecaptcha from "vue-recaptcha";
import NavBar from "@/components/shared/NavBar.vue";
import Breadcrumb from "@/components/shared/Breadcrumb.vue";
import SideBar from "@/components/shared/SideBar.vue";
import Footer from "@/components/shared/Footer.vue";
import { required, email, requiredIf } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      sitekey: "6LeHSqYZAAAAAIABXNPEW24txMYUSBwLEyVWjTri",
      secretkey: "6LeHSqYZAAAAAPiF8FaHJ3V59toGYd2ltMeXBd8D",
      pageSlug: this.$route.params.slug,
      errors: [],
      FormResult: null,
      userData: {
        userName: "",
        userSurname: "",
        dateOfBirth: "",
        education: "",
        homeAddress: "",
        militaryStatus: "",
        phoneNumber: "",
        email: "",
        location: "",
        identificationNumber: "",
        gender: "",
        maritalStatus: "",
        drivingLicense: "",
        drivingLicenseClass: "",
        shiftWork: "", // Shift Work Availability
        languages: [], // Array to store languages and levels
        currentLanguage: "", // Current language being added
        currentLevel: "", // Current level being added
        totalWorkExperience: "", // Total Work Experience
        positionApplyingFor: "", // Position You Are Applying For
        securityLicenseIssueDate: "", // Security Guard License Issue Date
        securityLicenseExpiryDate: "", // Security Guard License Expiry Date
        emergencyContact: {
          name: "",
          relationship: "",
          phoneNumber: "",
          kvkkConsent: false,
        },
        candidateConsent: false,
      },
      isSubmitted: false,
      showSuccessModal: false,
      successModalTimer: null,
      locations: [
        "ADANA",
        "ADIYAMAN",
        "AFYONKARAHİSAR",
        "AĞRI",
        "AMASYA",
        "ANKARA",
        "ANTALYA",
        "ARTVİN",
        "AYDIN",
        "BALIKESİR",
        "BİLECİK",
        "BİNGÖL",
        "BİTLİS",
        "BOLU",
        "BURDUR",
        "BURSA",
        "ÇANAKKALE",
        "ÇANKIRI",
        "ÇORUM",
        "DENİZLİ",
        "DİYARBAKIR",
        "EDİRNE",
        "ELAZIĞ",
        "ERZİNCAN",
        "ERZURUM",
        "ESKİŞEHİR",
        "GAZİANTEP",
        "GİRESUN",
        "GÜMÜŞHANE",
        "HAKKARİ",
        "HATAY",
        "ISPARTA",
        "MERSİN",
        "İSTANBUL",
        "İZMİR",
        "KARS",
        "KASTAMONU",
        "KAYSERİ",
        "KIRKLARELİ",
        "KIRŞEHİR",
        "KOCAELİ",
        "KONYA",
        "KÜTAHYA",
        "MALATYA",
        "MANİSA",
        "KAHRAMANMARAŞ",
        "MARDİN",
        "MUĞLA",
        "MUŞ",
        "NEVŞEHİR",
        "NİĞDE",
        "ORDU",
        "RİZE",
        "SAKARYA",
        "SAMSUN",
        "SİİRT",
        "SİNOP",
        "SİVAS",
        "TEKİRDAĞ",
        "TOKAT",
        "TRABZON",
        "TUNCELİ",
        "ŞANLIURFA",
        "UŞAK",
        "VAN",
        "YOZGAT",
        "ZONGULDAK",
        "AKSARAY",
        "BAYBURT",
        "KARAMAN",
        "KIRIKKALE",
        "BATMAN",
        "ŞIRNAK",
        "BARTIN",
        "ARDAHAN",
        "IĞDIR",
        "YALOVA",
        "KARABüK",
        "KİLİS",
        "OSMANİYE",
        "DÜZCE",
      ],
      town: "",
      selectedLocation: "",
      preferredCity1: "",
      preferredCity2: "",
    };
  },
  head: {
    script: [
      {
        type: "text/javascript",
        src:
          "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit",
        async: true,
        body: true,
      },
      { t: "application/ld+json", i: '{ "@context": "http://schema.org" }' },
    ],
  },
  components: {
    NavBar,
    Breadcrumb,
    SideBar,
    VueRecaptcha,
    Footer,
  },
  validations: {
    userData: {
      userName: {
        required,
      },
      userSurname: {
        required,
      },
      dateOfBirth: {
        required,
      },
      education: {
        required,
      },
      homeAddress: {
        required,
      },
      militaryStatus: {
        required,
      },
      phoneNumber: {
        required,
      },
      email: {
        required,
        email,
      },
      identificationNumber: {},
      gender: {
        required,
      },
      maritalStatus: {
        required,
      },
      drivingLicense: {
        required,
      },
      drivingLicenseClass: {},
      shiftWork: {
        required,
      },
      totalWorkExperience: {
        required,
      },
      positionApplyingFor: {
        required,
      },
      securityLicenseIssueDate: {
        required: requiredIf(function() {
          return this.positionsRequiringLicense.includes(
            this.userData.positionApplyingFor,
          );
        }),
      },
      securityLicenseExpiryDate: {
        required: requiredIf(function() {
          return this.positionsRequiringLicense.includes(
            this.userData.positionApplyingFor,
          );
        }),
        minDate: function(value) {
          if (!value || !this.userData.securityLicenseIssueDate) return true;
          return (
            new Date(value) >= new Date(this.userData.securityLicenseIssueDate)
          );
        },
      },
      emergencyContact: {
        name: {
          required,
        },
        relationship: {
          required,
        },
        phoneNumber: {
          required,
        },
        kvkkConsent: {
          required,
        },
      },
    },
    town: {
      required,
    },
    selectedLocation: {
      required,
    },
    preferredCity1: {
      required,
    },
    preferredCity2: {
      required,
    },
  },
  computed: {
    genderValues() {
      return {
        male: this.$t("jobAppFormLabels.genderValue.male"),
        female: this.$t("jobAppFormLabels.genderValue.female"),
      };
    },
    maritalStatusValues() {
      return {
        married: this.$t("jobAppFormLabels.maritalStatusValue.married"),
        single: this.$t("jobAppFormLabels.maritalStatusValue.single"),
      };
    },
    yesNoValues() {
      return {
        yes: this.$t("jobAppFormLabels.yesNoValue.yes"),
        no: this.$t("jobAppFormLabels.yesNoValue.no"),
      };
    },
    totalWorkExperienceValues() {
      return {
        no_experience: this.$t(
          "jobAppFormLabels.totalWorkExperienceValue.no_experience",
        ),
        "1_3_years": this.$t(
          "jobAppFormLabels.totalWorkExperienceValue.1_3_years",
        ),
        "3_5_years": this.$t(
          "jobAppFormLabels.totalWorkExperienceValue.3_5_years",
        ),
        "5_7_years": this.$t(
          "jobAppFormLabels.totalWorkExperienceValue.5_7_years",
        ),
        "7_10_years": this.$t(
          "jobAppFormLabels.totalWorkExperienceValue.7_10_years",
        ),
        "10_plus_years": this.$t(
          "jobAppFormLabels.totalWorkExperienceValue.10_plus_years",
        ),
      };
    },
    positionValues() {
      return {
        armed_security_officer: this.$t(
          "jobAppFormLabels.positionValue.armed_security_officer",
        ),
        unarmed_security_officer: this.$t(
          "jobAppFormLabels.positionValue.unarmed_security_officer",
        ),
        security_supervisor: this.$t(
          "jobAppFormLabels.positionValue.security_supervisor",
        ),
        reception_information_officer: this.$t(
          "jobAppFormLabels.positionValue.reception_information_officer",
        ),
        k9_handler: this.$t("jobAppFormLabels.positionValue.k9_handler"),
        administrative_staff: this.$t(
          "jobAppFormLabels.positionValue.administrative_staff",
        ),
        managerial_staff: this.$t(
          "jobAppFormLabels.positionValue.managerial_staff",
        ),
        other: this.$t("jobAppFormLabels.positionValue.other"),
      };
    },
    relationshipValues() {
      return {
        mother: this.$t("jobAppFormLabels.relationshipValue.mother"),
        father: this.$t("jobAppFormLabels.relationshipValue.father"),
        sibling: this.$t("jobAppFormLabels.relationshipValue.sibling"),
        spouse: this.$t("jobAppFormLabels.relationshipValue.spouse"),
        child: this.$t("jobAppFormLabels.relationshipValue.child"),
        friend: this.$t("jobAppFormLabels.relationshipValue.friend"),
      };
    },
    positionsRequiringLicense() {
      return [
        this.$t("jobAppFormLabels.positionValue.armed_security_officer"),
        this.$t("jobAppFormLabels.positionValue.unarmed_security_officer"),
        this.$t("jobAppFormLabels.positionValue.security_supervisor"),
        this.$t("jobAppFormLabels.positionValue.k9_handler"),
      ];
    },
    foreignLanguageValues() {
      return {
        english: this.$t("jobAppFormLabels.foreignLanguageValue.english"),
        arabic: this.$t("jobAppFormLabels.foreignLanguageValue.arabic"),
        french: this.$t("jobAppFormLabels.foreignLanguageValue.french"),
        persian: this.$t("jobAppFormLabels.foreignLanguageValue.persian"),
        russian: this.$t("jobAppFormLabels.foreignLanguageValue.russian"),
        other: this.$t("jobAppFormLabels.foreignLanguageValue.other"),
      };
    },
    foreignLanguageLevelValues() {
      return {
        good: this.$t("jobAppFormLabels.foreignLanguageLevelValue.good"),
        medium: this.$t("jobAppFormLabels.foreignLanguageLevelValue.medium"),
        bad: this.$t("jobAppFormLabels.foreignLanguageLevelValue.bad"),
      };
    },
  },

  methods: {
    addLanguage() {
      // Add the selected language and level to userData.languages
      if (this.userData.currentLanguage && this.userData.currentLevel) {
        this.userData.languages.push({
          language: this.userData.currentLanguage,
          level: this.userData.currentLevel,
        });

        // Reset language and level selections
        this.userData.currentLanguage = "";
        this.userData.currentLevel = "";
      }
    },

    removeLanguage(index) {
      // Remove a language and level at the specified index
      this.userData.languages.splice(index, 1);
    },

    submitted(e) {
      if (!this.userData.kvkkConsent || !this.userData.candidateConsent) {
        this.errors.push("Please check KVKK consents.");
        return;
      }
      this.isSubmitted = true;
      e.preventDefault();
      this.$refs.invisibleRecaptcha.execute();
    },
    onVerify: function(recaptchaToken) {
      this.resetForm();
      this.resetRecaptcha();

      let config = {
        headers: {
          Authorization: "Token 3f1c945dda80e43cd5683c8443092787",
          "Content-Type": "application/json",
        },
      };
      let myData = {
        content:
          "Name" +
          "=" +
          this.userData.userName +
          "&" +
          "Surname" +
          "=" +
          this.userData.userSurname +
          "&" +
          "identificationNumber" +
          "=" +
          this.userData.identificationNumber +
          "&" + // Identification Number
          "gender" +
          "=" +
          this.userData.gender +
          "&" + // Gender
          "dateOfBirth" +
          "=" +
          this.userData.dateOfBirth +
          "&" + // Date of Birth
          "maritalStatus" +
          "=" +
          this.userData.maritalStatus +
          "&" + // Marital Status
          "education" +
          "=" +
          this.userData.education +
          "&" + // Education
          "foreignLanguage" +
          "=" +
          JSON.stringify(this.userData.languages) +
          "&" + // Foreign Languages
          "homeAddress" +
          "=" +
          this.userData.homeAddress +
          "&" + // Home Address
          "location" +
          "=" +
          this.selectedLocation +
          "&" + // Location
          "town" +
          "=" +
          this.town +
          "&" + // Town
          "preferredCity1" +
          "=" +
          this.preferredCity1 +
          "&" + // Preferred City 1st Choice
          "preferredCity2" +
          "=" +
          this.preferredCity2 +
          "&" + // Preferred City 2nd Choice
          "militaryStatus" +
          "=" +
          this.userData.militaryStatus +
          "&" + // Military Status
          "drivingLicense" +
          "=" +
          this.userData.drivingLicense +
          "&" + // Driving License
          "drivingLicenseClass" +
          "=" +
          this.userData.drivingLicenseClass +
          "&" + // Driving License Class
          "phoneNumber" +
          "=" +
          this.userData.phoneNumber +
          "&" + // Phone Number
          "email" +
          "=" +
          this.userData.email +
          "&" + // Email Address
          "totalWorkExperience" +
          "=" +
          this.userData.totalWorkExperience +
          "&" + // Total Work Experience
          "positionApplyingFor" +
          "=" +
          this.userData.positionApplyingFor +
          "&" + // Position You Are Applying For
          "securityLicenseIssueDate" +
          "=" +
          this.userData.securityLicenseIssueDate +
          "&" + // Security Guard License Issue Date
          "securityLicenseExpiryDate" +
          "=" +
          this.userData.securityLicenseExpiryDate +
          "&" + // Security Guard License Expiry Date
          "shiftWork" +
          "=" +
          this.userData.shiftWork +
          "&" + // Shift Work Availability
          "emergencyContactName" +
          "=" +
          this.userData.emergencyContact.name +
          "&" + // Emergency Contact - Name
          "emergencyContactRelationship" +
          "=" +
          this.userData.emergencyContact.relationship +
          "&" + // Emergency Contact - Degree of Relationship
          "emergencyContactPhoneNumber" +
          "=" +
          this.userData.emergencyContact.phoneNumber +
          "&" +
          "candidateConsent" +
          "=" +
          this.userData.candidateConsent,
        application: this.$application,
        language: this.$t("languageCode"),
        dynamicField: "5ee7e12c9a24df0df44eeedd",
      };

      let secondData = JSON.stringify(myData);
      let errorMessage = this.$t("errorMessage");
      let vm = this;

      axios
        .post("https://recaptcha-verifier.tavitlab.com", {
          siteKey: this.sitekey,
          captchaToken: recaptchaToken,
        })
        .then(function(response) {
          if (response.data.result == true) {
            axios
              .post("https://api.tavguvenlik.com/forms", secondData, config)
              .then((response) => {
                if (response.data.result == true) {
                  vm.resetFormData();
                  vm.openSuccessModal();
                } else {
                  alert(errorMessage);
                }
                //document.location = document.location.href;
              })
              .catch((error) => {
                console.log(error);
                alert(errorMessage);
                //document.location = document.location.href;
              });
          } else {
            // document.location = document.location.href;
          }
        })
        .catch(function(error) {
          console.log(error);
          // document.location = document.location.href;
        });
      this.resetForm();
    },
    onExpired: function() {
      this.resetRecaptcha();
    },
    resetRecaptcha() {
      this.$refs.invisibleRecaptcha.reset();
    },
    resetForm() {
      this.$refs.contactUsForm.reset();
    },
    resetFormData() {
      this.userData = {
        userName: "",
        userSurname: "",
        dateOfBirth: "",
        education: "",
        homeAddress: "",
        militaryStatus: "",
        phoneNumber: "",
        email: "",
        location: "",
        identificationNumber: "",
        gender: "",
        maritalStatus: "",
        drivingLicense: "",
        drivingLicenseClass: "",
        shiftWork: "",
        languages: [],
        currentLanguage: "",
        currentLevel: "",
        totalWorkExperience: "",
        positionApplyingFor: "",
        securityLicenseIssueDate: "",
        securityLicenseExpiryDate: "",
        emergencyContact: {
          name: "",
          relationship: "",
          phoneNumber: "",
          kvkkConsent: false,
        },
        kvkkConsent: false,
        candidateConsent: false,
      };
      this.town = "";
      this.selectedLocation = "";
      this.preferredCity1 = "";
      this.preferredCity2 = "";
      if (this.$v) {
        this.$v.$reset();
      }
    },
    openSuccessModal() {
      this.showSuccessModal = true;
      document.body.style.overflow = "hidden";
      this.successModalTimer = setTimeout(this.closeSuccessModal, 5000);
    },
    closeSuccessModal() {
      this.showSuccessModal = false;
      document.body.style.overflow = "";
      if (this.successModalTimer) {
        clearTimeout(this.successModalTimer);
        this.successModalTimer = null;
      }
    },
  },
  beforeDestroy() {
    if (this.successModalTimer) {
      clearTimeout(this.successModalTimer);
    }
    document.body.style.overflow = "";
  },
};
</script>

<style scoped>
.success-modal-overlay {
  position: fixed;
  inset: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  padding: 1rem;
}

.success-modal-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
}

.success-modal-img {
  display: block;
  max-width: 90vw;
  max-height: 90vh;
  width: auto;
  height: auto;
  border-radius: 6px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.35);
}

.success-modal-close {
  position: absolute;
  top: -14px;
  right: -14px;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background: #fff;
  color: #1a2a52;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

.success-modal-fade-enter-active,
.success-modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.success-modal-fade-enter-active .success-modal-content,
.success-modal-fade-leave-active .success-modal-content {
  transition: transform 0.2s ease;
}

.success-modal-fade-enter,
.success-modal-fade-leave-to {
  opacity: 0;
}

.success-modal-fade-enter .success-modal-content,
.success-modal-fade-leave-to .success-modal-content {
  transform: scale(0.9);
}

.candidate-consent-row {
  display: flex;
  align-items: flex-start;
  gap: 0.35rem;
}
.candidate-consent-cb {
  flex-shrink: 0;
  margin-top: 0.2rem;
}
.candidate-consent-text {
  flex: 1;
  min-width: 0;
  line-height: 1.45;
}
.candidate-consent-link {
  display: inline !important;
}
.candidate-consent-tail {
  display: inline;
}
</style>
